(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var ROOT_SEL = '.elfsight-app-3b52ecb3-1936-4720-a879-b5139e88e6ea';
  var BUBBLE_SEL =
    '[class*="Bubble__BubbleComponent-sc"], [class*="BubbleBubbleComponent-sc"]';

  function walk(node, onMatch) {
    if (!node || node.nodeType !== 1) return;

    if (node.matches && node.matches(BUBBLE_SEL)) onMatch(node);

    if (node.shadowRoot) walk(node.shadowRoot, onMatch);

    var children = node.children;
    for (var i = 0; i < children.length; i++) walk(children[i], onMatch);
  }

  function attach() {
    var root = document.querySelector(ROOT_SEL);
    var matched = false;

    walk(root || document.body, function (el) {
      el.classList.add('exposure-whatsapp-vibrate');
      matched = true;
    });

    if (!matched) {
      var fallback = document.querySelector(BUBBLE_SEL);
      if (fallback) {
        fallback.classList.add('exposure-whatsapp-vibrate');
        matched = true;
      }
    }

    return matched;
  }

  function init() {
    if (attach()) return;

    var observer = new MutationObserver(function () {
      if (attach()) observer.disconnect();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });

    window.setTimeout(function () {
      observer.disconnect();
    }, 45000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
